var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"text-page"}},[_c('h1',{staticClass:"page-title"},[_vm._v("Aviso de Privacidad")]),_vm._v(" "),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.row)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }